import { z } from "zod";
import { Timestamp } from "../../common";

/** How many invites an account is given when it's admitted. */
export const INVITES_PER_MEMBER = 3;

/** Where an invite link opens on the web: `/invites/<code>`. */
export const INVITE_PATH_PREFIX = "/invites/";

export const WaitlistInviteCode = z
  .string()
  .regex(/^[0-9a-z]{16}$/)
  .meta({
    id: "WaitlistInviteCode",
    description:
      "The secret in an invite link, `/invites/<code>`: 16 lowercase letters and digits.",
    example: "k3v9q2m7x1d8p4ra",
  });

export const WaitlistInvite = z
  .strictObject({
    code: WaitlistInviteCode,
    createdAt: Timestamp,
    redeemedAt: Timestamp.nullable().meta({
      description: "When someone used it to get in, or null while it's still free to hand out.",
    }),
  })
  .meta({
    id: "WaitlistInvite",
    description: "One invite link the caller can hand out.",
    example: {
      code: "k3v9q2m7x1d8p4ra",
      createdAt: "2026-11-04T18:00:00.000Z",
      redeemedAt: null,
    },
  });
export type WaitlistInvite = z.infer<typeof WaitlistInvite>;

export const ListWaitlistInvitesResponse = z.strictObject({ items: z.array(WaitlistInvite) }).meta({
  id: "ListWaitlistInvitesResponse",
  description: "The caller's invites, oldest first.",
});
export type ListWaitlistInvitesResponse = z.infer<typeof ListWaitlistInvitesResponse>;

export const RedeemWaitlistInviteParams = z.strictObject({ code: WaitlistInviteCode });
